import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import * as customBuild from "../../customCkEditor/build/ckeditor";
import { MyUploadAdapter } from "./uploadAdapter";

@Component({
  selector: "app-rich-text-editor",
  templateUrl: "./rich-text-editor.component.html",
  styleUrls: ["./rich-text-editor.component.css"],
})
export class RichTextEditorComponent implements OnInit, OnDestroy {
  @Input() value;
  @Input() readonly: boolean;

  Editor = customBuild;

  public onReady(editor) {
    /*editor.ui
      .getEditableElement()
      .parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );*/
  }
  heading = {
    options: [
      { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
      {
        model: "heading3",
        view: "h3",
        title: "Heading 3",
        class: "ck-heading_heading3",
      },
      {
        model: "heading4",
        view: "h4",
        title: "Heading 4",
        class: "ck-heading_heading4",
      },
      {
        model: "heading5",
        view: "h5",
        title: "Heading 5",
        class: "ck-heading_heading5",
      },
      {
        model: "heading6",
        view: "h6",
        title: "Heading 6",
        class: "ck-heading_heading6",
      },
    ],
  };
  public config2 = {
    toolbar: {
      items: [
        "heading",
        "|",
        "fontSize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "underline",
        "|",
        "alignment",
        "|",
        "numberedList",
        "bulletedList",
        "|",
        "outdent",
        "indent",
        "|",
        "todoList",
        "link",
        "blockQuote",
        "ImageUpload",
        "mediaEmbed",
        "insertTable",
        "|",
        "undo",
        "redo",
        "pageBreak",
        "|",
        "findAndReplace",
      ],
    },
    language: "es",
    image: {
      toolbar: ["imageTextAlternative", "imageStyle:side"],
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties",
      ],
    },
  };

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.creaEditor();
    });
  }

  creaEditor() {
    customBuild
      .create(document.querySelector(".document-editor__editable"), {
        fontSize: { options: [9, "default", 11, 12, 13, 16, 17, 19, 21] },
        licenseKey:
          "cDdvR2JOTy9Fdnc2dit3QzNQTklJTGFNUjFydEdQeWRjWFlRYUdJeTg3elJQdG5hS0E9PS1NakF5TlRBek1UUT0=",
        toolbar: this.config2.toolbar,
        ckfinder: {
          options: {
            resourceType: "Images",
          },
        },
        heading: this.heading,
      })
      .then((editor) => {
        const toolbarContainer = document.querySelector(
          ".document-editor__toolbar"
        );
        toolbarContainer.appendChild(editor.ui.view.toolbar.element);
        if (this.readonly) {
          editor.enableReadOnlyMode("lock");
        }
        this.Editor = editor;
        this.Editor.setData(this.value);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  ngOnDestroy(): void {
    console.log("Destruyendo el editor...");
    this.Editor.destroy();
    console.log("Editor destruido.");
  }

  customUploadAdapterPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new MyUploadAdapter(loader);
    };
  }
}
